module.exports = __webpack_public_path__ + "img/10.f94a160b.png";